import { lazy, Suspense } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

import ErrorBoundary from "./components/ErrorBoundary";
import { AuthProvider } from "./hooks/useAuth";
import { DashboardLayout } from "./layouts/DashboardLayout";

// Lazy load from pages
const AuthLoginRoute = lazy(() =>
  import("./pages/Login").then((module) => ({
    default: module.AuthLoginRoute,
  }))
);
const BatteryPassportDetailsPage = lazy(() =>
  import("@/features/BatteryPassports/_slug/view/index").then((module) => ({
    default: module.BatteryPassportDetailRoute,
  }))
);
const DashboardPage = lazy(() => import("./pages/Dashboard"));
const BatteryPassportsPage = lazy(() => import("./pages/BatteryPassports"));
const BatteryModelsPage = lazy(() => import("./pages/BatteryModels"));
const MaterialsPage = lazy(() => import("./pages/Materials"));
const PartnersPage = lazy(() => import("./pages/Partners"));
const AccessControlPage = lazy(() => import("./pages/AccessControl"));
const InboxPage = lazy(() => import("./pages/Inbox"));

const RouteLoading = () => (
  <div className="flex h-48 items-center justify-center p-8">
    <p className="animate-pulse text-muted-foreground">Loading...</p>
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ErrorBoundary>
          <Suspense fallback={<RouteLoading />}>
            <Routes>
              <Route element={<AuthLoginRoute />} path="/auth/login" />
              <Route element={<BatteryPassportDetailsPage />} path="/bp/:id" />

              <Route element={<DashboardLayout />}>
                <Route element={<Navigate replace to="/overview" />} path="/" />
                <Route element={<DashboardPage />} path="/overview/*" />
                <Route
                  element={<BatteryPassportsPage />}
                  path="/battery-passports/*"
                />
                <Route
                  element={<BatteryModelsPage />}
                  path="/battery-models/*"
                />
                <Route element={<MaterialsPage />} path="/materials/*" />
                <Route element={<PartnersPage />} path="/partners/*" />
                <Route
                  element={<AccessControlPage />}
                  path="/access-control/*"
                />
                <Route element={<InboxPage />} path="/inbox/*" />
              </Route>

              {/* Catch-all redirect */}
              <Route element={<Navigate replace to="/" />} path="*" />
            </Routes>
          </Suspense>
        </ErrorBoundary>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
